import { render, staticRenderFns } from "./GSchoolClassChange.vue?vue&type=template&id=09e0efdb&scoped=true&"
import script from "./GSchoolClassChange.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassChange.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClassChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0efdb",
  null
  
)

export default component.exports